<p-blockui
  *ngIf="blocked"
  [target]="resolvedTarget"
  [blocked]="blocked && isDisplayed"
  styleClass="bg-black bg-opacity-50 transition-colors duration-500"
  [ngClass]="{ 'position-centered': positionCentered, 'display-none': !isDisplayed, 'grey-bg': blockerType }"
>
  <div class="-mt-16 text-center text-white dialog-simulator">
    <div class="p-element ng-trigger p-dialog p-component p-dialog-resizable">
      <div class="p-dialog-header">
        <span class="p-dialog-title">
          <p-header class="">
            <div class="d-flex flex-prototype" style="flex-direction: column">
              <ng-container [ngSwitch]="blockerType">
                <ng-template [ngSwitchCase]="'GEN_AI_IMPORT'">
                  {{ 'IMPORT_BLOCKER_HEADER' | translate }}
                </ng-template>
                <ng-template [ngSwitchCase]="'GEN_AI_MERGE'">
                  {{ 'MERGE_BLOCKER_HEADER' | translate }}
                </ng-template>
                <ng-template [ngSwitchCase]="'GEN_AI_PRMOPT_GENERATION'">
                  {{ 'PROMPT_GENERATION_HEADER' | translate }}
                </ng-template>
                <ng-template [ngSwitchCase]="'GEN_AI_FIELD_GENERATION'">
                  {{ 'FIELD_GENERATION_HEADER' | translate }}
                </ng-template>
                <ng-template [ngSwitchCase]="'COMPONENT_GENERATION'">
                  {{ 'COMPONENT_GENERATION_HEADER' | translate: { component: 'Module' } }}
                </ng-template>
                <ng-template [ngSwitchDefault]>
                  {{ 'NOTIFICATION' | translate }}
                </ng-template>
              </ng-container>
            </div>
          </p-header>
        </span>
      </div>
      <div class="p-dialog-content" [ngClass]="{ 'border-bottom-radius': !unblockAllowed }">
        <ng-container [ngSwitch]="blockerType">
          <ng-template [ngSwitchCase]="'GEN_AI_IMPORT'">
            <div class="d-flex align-items-center" style="gap: 10px; padding: 10px">
              <vb-app-loader-animated></vb-app-loader-animated>
              <div class="content" style="padding: 10px">
                {{ 'IMPORT_BLOCKER_TEXT' | translate }}
                <br />
                {{ importPercent }}% {{ importStatus | translate }}...
              </div>
            </div>
          </ng-template>
          <ng-template [ngSwitchCase]="'GEN_AI_MERGE'">
            <div class="d-flex align-items-center" style="gap: 10px; padding: 10px">
              <vb-app-loader-animated></vb-app-loader-animated>
              <div class="content" style="padding: 10px">
                {{ 'MERGE_BLOCKER_TEXT' | translate }}
              </div>
            </div>
          </ng-template>
          <ng-template [ngSwitchCase]="'GEN_AI_PRMOPT_GENERATION'">
            <div class="d-flex align-items-center" style="gap: 10px; padding: 10px">
              <vb-app-loader-animated></vb-app-loader-animated>
              <div class="content" style="padding: 10px">
                {{ 'PROMPT_GENERATION_TEXT' | translate }}
                <br />
                {{ importPercent }}% {{ importStatus | translate }}...
              </div>
            </div>
          </ng-template>
          <ng-template [ngSwitchCase]="'GEN_AI_FIELD_GENERATION'">
            <div class="d-flex align-items-center" style="gap: 10px; padding: 10px">
              <vb-app-loader-animated></vb-app-loader-animated>
              <div class="content" style="padding: 10px">
                {{ 'FIELD_GENERATION_TEXT' | translate }}
                <br />
                {{ importPercent }}% {{ importStatus | translate }}...
              </div>
            </div>
          </ng-template>
          <ng-template [ngSwitchCase]="'COMPONENT_GENERATION'">
            <div class="d-flex align-items-center component-generation-content" style="gap: 10px; padding: 10px">
              <i class="pi pi-sparkles ai-sparkle-icon"></i>
              <div class="content" style="padding: 10px">
                {{ 'COMPONENT_GENERATION_IN_PROGRESS' | translate }}
                <!-- <br />
                {{ importPercent }}% {{ importStatus | translate }}... --->
              </div>
            </div>
          </ng-template>
          <ng-template [ngSwitchCase]="'BULK_ACL'">
            <div class="d-flex align-items-center" style="gap: 10px; padding: 10px">
              <vb-app-loader-animated></vb-app-loader-animated>
              <div
                class="content"
                style="padding: 10px"
                innerHTML="{{ 'ROLE_ACL_COPY_BLOCKER_TEXT' | translate: { initiator: data.initiatedBy } }}"
              ></div>
            </div>
          </ng-template>
          <ng-template [ngSwitchCase]="'VIBE_BUILD'">
            <div class="d-flex align-items-center" style="gap: 10px; padding: 10px">
              <vb-app-loader-animated></vb-app-loader-animated>
              <div
                class="content"
                style="padding: 10px"
                innerHTML="{{ 'VIBE_BUILD_BLOCKER_TEXT' | translate: { initiator: data.initiatedBy } }}"
              ></div>
            </div>
          </ng-template>
          <ng-template [ngSwitchDefault]>
            <div class="row">
              <div class="col">
                <i class="pi pi-spin pi-spinner" style="font-size: 3rem" *ngIf="!unblockAllowed"></i>
                <div
                  class="{{ messageVisible ? 'opacity-100' : 'opacity-0' }} mt-2 transition-all delay-100 duration-200"
                >
                  <p class="font-bold" innerHtml="{{ message }}"></p>
                </div>
              </div>
            </div>
          </ng-template>
        </ng-container>
      </div>
      <div class="p-dialog-footer" *ngIf="unblockAllowed">
        <div class="">
          <div class="d-flex align-items-right">
            <button type="button" class="unblock-btn" (click)="unBlock(true)">{{ unblockBtnLabel }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</p-blockui>
